import http from 'axios'

export default {
  getConfigurationGraine: (codeGraineRs3) => {
    return http.get(`/web/v1/reperes-economiques/configuration/${codeGraineRs3}`)
  },
  getReperesEconomiques: () => {
    return http.get(`/web/v1/reperes-economiques/configuration`)
  },
  updateRepereEconomiqueItem: (item) => {
    return http.put(`/web/v1/reperes-economiques/configuration/item`, item)
  },
  getReperesEconomiquesByGraine: (username, codeGraineRs3) => {
    return http.get(`/web/v1/${username}/reperes-economiques/${codeGraineRs3}`)
  },
  create: (username, reperesEconomiques) => {
    return http.post(`/web/v1/${username}/reperes-economiques`, reperesEconomiques)
  },
  update: (username, reperesEconomiques) => {
    return http.put(`/web/v1/${username}/reperes-economiques`, reperesEconomiques)
  },
}
